import {
  TREES_FETCH,
  TREE_FETCH_BY_ID,
  TREE_CREATE,
  TREE_UPDATE,
  TREES_ASSIGN_JOB,
} from '../actions';

const INIT_STATE = {
  list: [],
  current: null,
};

export default function treesReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case TREES_FETCH.SUCCESS:
      return { ...state, list: action.payload };
    case TREE_FETCH_BY_ID.SUCCESS:
      return { ...state, current: action.payload };
    case TREE_CREATE.SUCCESS:
      return { ...state, list: [...state.list, action.payload], current: action.payload };
    case TREE_UPDATE.SUCCESS: {
      const list = state.list.map((t) =>
        t.tree_id === action.payload.tree_id ? action.payload : t
      );
      return { ...state, list, current: action.payload };
    }
    case TREES_ASSIGN_JOB.SUCCESS: {
      const assigned = action.payload;
      const ids = new Set(assigned.map((t) => t.tree_id));
      const list = state.list.map((t) => {
        const updated = assigned.find((a) => a.tree_id === t.tree_id);
        return updated || t;
      });
      return { ...state, list };
    }
    default:
      return state;
  }
}
